import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, convertToUppercase } from '../../../../utils/util';
import { Input, SelectJustification } from '../../../../components/UI/ComponentsUI';

const DropMaterialArea = (props) => {
    const onChange = (event) => {
        props.onChange(event);
    };

    return (
        <div>
            <div className="input-field no-padding col s12">
                <Input
                    required
                    label={translate('stock:location')}
                    id="area"
                    name="area"
                    type="text"
                    onChange={(event) => { convertToUppercase(event); onChange(event); }}
                    defaultValue={props.filter?.area}
                />
            </div>
            {!props.pabReplanning &&
                <div className="input-field no-padding col s12" >
                    <SelectJustification
                        required
                        type={6}
                        value={props.filter?.justification || ''}
                        onChange={onChange}
                    />
                </div>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DropMaterialArea));